export default __webpack_public_path__ + "70cb14388c37d0b02d498c74a01633c1.png";